var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container products-page"},[_c('div',{attrs:{"id":"TestContainer"}},_vm._l((_vm.itemList),function(item,idx){return _c('div',{key:'item_' + idx,staticClass:"box"},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }